export default {
  disabled: {
    title: 'La fatturazione non è gestita sulla piattaforma',
    description:
      'Abbonamenti e fatture non sono disponibili perché la fatturazione tra te e i tuoi ristoranti avviene fuori dalla piattaforma. Pagamenti, estratti conto e report rimangono disponibili.',
  },
};
